<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useTheme } from 'vuetify';

  import { useI18 } from '@/plugins';
  import { useAuthStore } from '@/stores/auth.store';
  const authStore = useAuthStore();
  const { showAsMenu } = defineProps<{
    showAsMenu: boolean;
  }>();
  const theme = useTheme();
  const isClicked = ref(false);

  function toggleTheme(themeVar: string) {
    theme.global.name.value = themeVar;
    localStorage.setItem('theme', themeVar);
    isClicked.value = !isClicked.value;
  }
  const { t } = useI18();
  const themeVariables = [
    {
      value: 'myCustomLightTheme',
      name: t('shared.light'),
    },
    {
      value: 'myCustomDarkTheme',
      name: t('shared.dark'),
    },
  ];
  const isDarkTheme = computed(
    () => theme.global.name.value === 'myCustomDarkTheme'
  );
</script>
<template>
  <v-menu v-if="showAsMenu">
    <template #activator="{ props, isActive }">
      <div class="d-flex ga-2 align-center text-capitalize" v-bind="props">
        {{ isDarkTheme ? t('shared.dark') : t('shared.light') }}
        <v-icon :icon="isActive ? 'mdi-menu-up' : 'mdi-menu-down'"></v-icon>
      </div>
    </template>
    <v-list>
      <v-list-item
        v-for="themeVar in themeVariables"
        :key="themeVar.value"
        :value="themeVar.value"
        class="w-100 d-flex justify-center"
        @click="toggleTheme(themeVar.value)"
      >
        <v-btn
          size="small"
          variant="flat"
          :class="
            themeVar.value === 'myCustomLightTheme'
              ? 'bg-blue-50'
              : ' bg-themeBtn'
          "
          icon
          class="rounded-pill"
          aria-label="Toggle theme"
          @click="toggleTheme(themeVar.value)"
        >
          <template #default>
            <v-icon
              :color="
                themeVar.value === 'myCustomLightTheme'
                  ? 'blue-800'
                  : 'themeIcon'
              "
              :icon="
                themeVar.value === 'myCustomLightTheme'
                  ? 'mdi-weather-sunny'
                  : 'mdi-weather-night'
              "
            >
            </v-icon>
          </template>
        </v-btn>
      </v-list-item>
    </v-list>
  </v-menu>

  <v-btn
    v-else
    size="small"
    variant="flat"
    icon
    class="rounded-pill bg-themeBtn"
    aria-label="Toggle theme"
    @click="
      toggleTheme(`${isDarkTheme ? 'myCustomLightTheme' : 'myCustomDarkTheme'}`)
    "
  >
    <template #default>
      <v-icon
        color="themeIcon"
        :icon="isDarkTheme ? 'mdi-weather-sunny' : 'mdi-weather-night'"
      >
      </v-icon>
    </template>
  </v-btn>
</template>

<style lang="scss">
  .themeToggle {
    transition: 1s ease;
  }
  .themeToggle.rotate {
    transform: scale(1) rotate(360deg);
  }
</style>
